import { BrowserRouter, Routes, Route } from "react-router-dom";
import RequireAuth from "./components/auth/RequireAuth";
import RequireJefatura from "./components/auth/RequireJefatura";
import NotFound from "./pages/NotFound";
import EncuestaSatisfaccion from "./pages/EncuestaSatisfaccion";
import Layout from "./components/funcionarios/Layout";

import Inicio from "./pages/funcionarios/Inicio";
import Atencion from "./pages/funcionarios/Atencion";
import Fichas from "./pages/funcionarios/Fichas";
import Historial from "./pages/funcionarios/Historial";
import AdministradorModulos from "./pages/jefatura/AdministradorModulos";
import Dashboard from "./pages/jefatura/Dashboard";

import InicioEstudiante from "./pages/estudiantes/InicioEstudiante";
import Fila from "./pages/estudiantes/Fila";
import EsTuTurno from "./pages/estudiantes/EsTuTurno";

import FichaLectura from "./pages/funcionarios/FichaLectura";
import FichaAtendiendo from "./pages/funcionarios/FichaAtendiendo";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Inicio />} />
          <Route path="atencion">
            <Route index element={<Atencion />} />
            <Route
              path="ficha"
              element={<FichaAtendiendo fallback="/atencion" />}
            />
            <Route
              path="ficha/:idS"
              element={<FichaLectura fallback="/atencion" />}
            />
          </Route>
          <Route path="fichas">
            <Route index element={<Fichas />} />
            <Route path=":idS" element={<FichaLectura fallback="/fichas" />} />
          </Route>
          <Route path="historial">
            <Route index element={<Historial />} />
            <Route
              path=":idS"
              element={<FichaLectura fallback="/historial" />}
            />
          </Route>
          <Route
            path="modulos"
            element={
              <RequireJefatura>
                {" "}
                <AdministradorModulos />{" "}
              </RequireJefatura>
            }
          />
          <Route path="dashboard">
            <Route
              index
              element={
                <RequireJefatura>
                  {" "}
                  <Dashboard />{" "}
                </RequireJefatura>
              }
            />
            <Route
              path="ficha/:idS"
              element={
                <RequireJefatura>
                  {" "}
                  <FichaLectura fallback="/dashboard" />{" "}
                </RequireJefatura>
              }
            />
          </Route>
        </Route>

        {/* Rutas para estudiantes */}
        <Route path="/inicio" element={<InicioEstudiante />} />
        <Route path="/espera" element={<Fila />} />
        <Route path="/turno" element={<EsTuTurno />} />
        <Route path="/encuesta/:token" element={<EncuestaSatisfaccion />} />
        {/* Catch-all para rutas inválidas */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
